var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0625 0.275879H3.1875C2.34212 0.275879 1.53137 0.600124 0.933597 1.17728C0.335825 1.75444 0 2.53724 0 3.35347V13.6121C0 14.4283 0.335825 15.2111 0.933597 15.7883C1.53137 16.3654 2.34212 16.6897 3.1875 16.6897H18.0625C18.9079 16.6897 19.7186 16.3654 20.3164 15.7883C20.9142 15.2111 21.25 14.4283 21.25 13.6121V3.35347C21.25 2.53724 20.9142 1.75444 20.3164 1.17728C19.7186 0.600124 18.9079 0.275879 18.0625 0.275879ZM17.3506 2.3276L10.625 7.20045L3.89938 2.3276H17.3506ZM18.0625 14.6379H3.1875C2.90571 14.6379 2.63546 14.5299 2.4362 14.3375C2.23694 14.1451 2.125 13.8842 2.125 13.6121V3.60993L9.9875 9.30347C10.1714 9.43665 10.3951 9.50864 10.625 9.50864C10.8549 9.50864 11.0786 9.43665 11.2625 9.30347L19.125 3.60993V13.6121C19.125 13.8842 19.0131 14.1451 18.8138 14.3375C18.6145 14.5299 18.3443 14.6379 18.0625 14.6379Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e859915e85af1d0066f504be6e323eae.svg";
export { ForwardRef as ReactComponent };